import { useEffect } from "react";
import { ArrowRight } from "lucide-react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import PageHero from "@/components/PageHero";
import CTASection from "@/components/CTASection";
import { Button } from "@/components/ui/button";
const Events = () => {
  useEffect(() => {
    const pageTitle = "Events & Webinars | AuthorPro";
    const pageDescription = "Join AuthorPro events and webinars designed to help you maximize your success with AuthorPro.";
    document.title = pageTitle;
    let descriptionMeta = document.querySelector('meta[name="description"]') as HTMLMetaElement | null;
    if (!descriptionMeta) {
      descriptionMeta = document.createElement("meta");
      descriptionMeta.name = "description";
      document.head.appendChild(descriptionMeta);
    }
    descriptionMeta.content = pageDescription;
    const canonicalHref = `${window.location.origin}/events`;
    let canonicalLink = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (!canonicalLink) {
      canonicalLink = document.createElement("link");
      canonicalLink.rel = "canonical";
      document.head.appendChild(canonicalLink);
    }
    canonicalLink.href = canonicalHref;
  }, []);
  return <div className="min-h-screen">
      <Navbar />
      <main>
        <PageHero
          eyebrow="Events and webinars"
          title={
            <>
              See it live, then ask us{" "}
              <span className="text-gold-gradient">anything.</span>
            </>
          }
          intro="Every week we walk through how a finished book becomes an interactive, AI-powered platform — live demo, real reader journeys, and open Q&A with the team that builds them."
        />

        {/* Event Preview Layout */}
        <section className="py-20 md:py-28">
          <div className="container mx-auto px-4 max-w-2xl">
            <article className="card-noir relative overflow-hidden px-7 py-9 md:px-10 md:py-11">
              <span className="absolute inset-x-0 top-0 h-px gold-hairline" aria-hidden />
              <p className="eyebrow mb-5">Event preview</p>
              <h2 className="font-serif text-2xl md:text-[2rem] leading-snug mb-8">
                AuthorPro – Transform Your Book into a Consulting Platform
              </h2>

              <dl className="mb-8 text-sm md:text-base">
                <div className="flex items-center justify-between border-t border-border py-4">
                  <dt className="font-medium">Frequency</dt>
                  <dd className="text-muted-foreground">Weekly</dd>
                </div>
                <div className="flex items-center justify-between border-t border-border py-4">
                  <dt className="font-medium">Time</dt>
                  <dd className="text-muted-foreground">2pm – 3pm (UK)</dd>
                </div>
                <div className="flex items-center justify-between border-t border-b border-border py-4">
                  <dt className="font-medium">Cost</dt>
                  <dd className="text-muted-foreground">Free</dd>
                </div>
              </dl>

              <p className="text-[15px] md:text-base text-muted-foreground leading-relaxed mb-9">
                Join our weekly session to see how AuthorPro turns a book into a scalable consulting
                platform — with a live walkthrough and time for your questions.
              </p>

              <div className="flex flex-col items-start gap-3">
                <Button asChild size="lg" className="bg-gold text-gold-foreground hover:bg-gold-light font-semibold px-8 w-full sm:w-auto">
                  <a href="https://www.eventbrite.co.uk/e/authorproai-transform-your-book-into-a-consulting-platform-if-you-are-a-tickets-1977021721188?aff=oddtdtcreator" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2">
                    Get Free Tickets
                    <ArrowRight className="h-4 w-4" />
                  </a>
                </Button>
                <p className="text-xs text-muted-foreground">Secure your spot — places are limited each week.</p>
              </div>
            </article>
          </div>
        </section>


        <CTASection />
      </main>
      <Footer />
    </div>;
};
export default Events;